import HomePage from '../pages/HomePage/HomePage.vue'

const routes = [
    {name: "root",  path: '/', redirect: {name: 'home'}},
    {name: "home", path: '/home', component: HomePage},
]

export default routes

